// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserComponents_Image = require("./BrowserComponents_Image.bs.js");
var BrowserComponents_Modal = require("./BrowserComponents_Modal.bs.js");
var BrowserComponents_Button = require("./BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("./BrowserComponents_Spacer.bs.js");

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.flexBox),
      tl: {
        hd: BrowserStyle.flexDirection(BrowserStyle.column),
        tl: {
          hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
          tl: /* [] */0
        }
      }
    });

var image = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(5.4375)),
      tl: {
        hd: BrowserStyle.marginBottom(BrowserStyle.rem(1.5)),
        tl: {
          hd: BrowserStyle.width(BrowserStyle.rem(5.4375)),
          tl: /* [] */0
        }
      }
    });

function arg(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* XLarge */5, /* Bold */2);
}

var title = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), {
          hd: BrowserStyle.alignItems(BrowserStyle.center),
          tl: {
            hd: BrowserStyle.color({
                  TAG: /* Grey */2,
                  _0: /* Dark */1
                }),
            tl: {
              hd: BrowserStyle.display(BrowserStyle.flexBox),
              tl: {
                hd: BrowserStyle.flexDirection(BrowserStyle.column),
                tl: {
                  hd: BrowserStyle.justifyContent(BrowserStyle.center),
                  tl: {
                    hd: BrowserStyle.padding2(BrowserStyle.Spacing.medium, BrowserStyle.Spacing.small),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }));

function arg$1(param) {
  return BrowserStyle.withFont(param, /* OpenSans */1, /* Medium */3, /* Normal */0);
}

var subtext = Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined), {
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Medium */2
              }),
          tl: {
            hd: BrowserStyle.marginTop(BrowserStyle.zero),
            tl: /* [] */0
          }
        }));

var Styles = {
  container: container,
  image: image,
  title: title,
  subtext: subtext
};

function BrowserComponents_SubmissionErrorModal(Props) {
  var param = Props.cancelButton;
  var image$1 = Props.image;
  var okButton = Props.okButton;
  var subtext$1 = Props.subtext;
  var title$1 = Props.title;
  var onCancel = param.onClick;
  return React.createElement(BrowserComponents_Modal.Legacy.make, {
              children: null,
              className: container
            }, React.createElement("div", {
                  className: title
                }, React.createElement(BrowserComponents_Image.make, {
                      className: image,
                      image: {
                        TAG: /* Illustration */1,
                        _0: image$1
                      }
                    }), React.createElement("h3", undefined, React.createElement(ReactUtils.S.make, {
                          children: title$1
                        }))), React.createElement(BrowserComponents_Modal.Legacy.$$Text.make, {
                  className: subtext,
                  text: subtext$1
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Large */5
                }), Relude_Option.fold(null, (function (param) {
                    var onClick = param.onClick;
                    return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Button.make, {
                                    actionPriority: /* Primary */0,
                                    onClick: (function (param) {
                                        return Relude_Globals.$$const(onClick, param);
                                      }),
                                    title: param.text
                                  }), React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* Small */3
                                  }));
                  }), okButton), React.createElement(BrowserComponents_Button.make, {
                  actionPriority: /* LegacySecondary */2,
                  onClick: (function (param) {
                      return Relude_Globals.$$const(onCancel, param);
                    }),
                  title: param.text
                }));
}

var make = BrowserComponents_SubmissionErrorModal;

exports.Styles = Styles;
exports.make = make;
/* container Not a pure module */
